import { DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ClipboardModule } from 'ngx-clipboard';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { AutofacetsCoreModule } from '../../../Autofacets-Core/src/app/app.module';
import { AppIntializer } from './app-initializer';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ThemeResolver } from './Resolvers/theme.resolver';
import { AppConfigService } from './Services/app-config.service';
import { CommonLocalizationService } from './Services/common-localization.service';
import { CultureLocaleService } from './Services/culture-locale.service';
import { CustomLoader } from './Services/custom-loader.service';
import { DisclaimerInfoComponent } from './Shared/Components/disclaimer-info/disclaimer-info.component';
import { LandingPageComponent } from './Shared/Components/landing-page/landing-page.component';
import { LpAuthenticationComponent } from './Shared/Components/landing-page/lp-authentication/lp-authentication.component';
import { JwtAppInterceptor } from 'projects/Autofacets-Core/src/app/interceptor/jwt-app.interceptor';
import { StepModule } from './Views/Steps/step.module';
import { MockTranslateDirective } from './Services/mock-translate.directive';
import { AfDirectiveModule } from 'projects/Autofacets-Core/src/app/directives/af-directive-core.module';

export function createTranslateLoader(commonLocalizationService: CommonLocalizationService) {
  return new CustomLoader(commonLocalizationService);
}

@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    DisclaimerInfoComponent,
    LpAuthenticationComponent,
    MockTranslateDirective,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    NgbModule,
    FormsModule,
    NgxSpinnerModule,
    ClipboardModule,
    StepModule,
    TranslateModule,
    AutofacetsCoreModule.forRoot(),
    NgSelectModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [CommonLocalizationService]
      }
    }),
    AfDirectiveModule
  ],
  schemas: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtAppInterceptor, multi: true },
    AppConfigService,
    CultureLocaleService,
    {
      provide: APP_INITIALIZER,
      useFactory: AppIntializer,
      deps: [AppConfigService,CultureLocaleService],
      multi: true,
    },
    
    CookieService,
    DatePipe,
    ThemeResolver,
    CurrentLanguage,
    { 
      provide: LOCALE_ID, 
      deps: [CultureLocaleService],
      useFactory: (CultureLocaleService) => CultureLocaleService.getLocale()
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
